import { render, staticRenderFns } from "./InventorySummary.vue?vue&type=template&id=aef08f12&scoped=true"
import script from "./InventorySummary.vue?vue&type=script&lang=ts"
export * from "./InventorySummary.vue?vue&type=script&lang=ts"
import style0 from "./InventorySummary.vue?vue&type=style&index=0&id=aef08f12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef08f12",
  null
  
)

export default component.exports